export const BUILD_INFO = {
  buildNumber: '291020261172+0530D',
  environment: 'DEV'
};